import { DESIGN_TOKENS } from '@disqotech/vinyl-design-system/design-tokens';
import { DEVICE_BREAKPOINT, FONT_WEIGHTS, PARAGRAPH, TITLES_NORMAL } from "Shared/styles/designConstants";
import styled from "styled-components";

export const DocumentText = styled.div`
  ${PARAGRAPH.DEFAULT}

  & ul {
    list-style-type: disc;
    padding-left   : 16px;
  }

  & li {
    padding-left: 0;
  }

  & .privacy-sidebar-header {
    ${TITLES_NORMAL.FT_02}
  }

  & h2 {
    text-align: left;
    ${TITLES_NORMAL.FT_01}
  }

  & a {
    color          : ${DESIGN_TOKENS.color.text.link.value};
    text-decoration: none;
  }

  & .privacy-updated {
    margin-bottom: 16px;
  }

  & .privacy-item:first-child {
    padding-top: 10px;
  }

  & .privacy-item, & p {
    padding: 0 0 10px;
  }

  & .purpose-item {
    ${TITLES_NORMAL.FT_01}
  }

  & ul + p {
    padding-top: 10px;
  }

  & strong {
    font-weight: ${FONT_WEIGHTS.poppins_2}
  }

  & table {
    margin: 10px 0;
  }

  & td {
    border: 1px solid ${DESIGN_TOKENS.color.border.normal.value};
  }

  #california-consumer-privacy-act {
    table {
      display   : block;
      overflow-x: auto;
      width     : 100%;
    }

    tr:first-child td {
      min-width     : 190px;
      text-align    : center;
      vertical-align: middle;
    }

    td {
      padding: 5px 10px;
    }
  }
`;

export const DocumentTitle = styled.h1`
  ${TITLES_NORMAL.FT_02}
`;

export const DocumentUpdated = styled.h1`
  ${PARAGRAPH.DEFAULT}
`;

export const DocumentContent = styled.div`
  max-width: 800px;
  margin   : 0 auto;

  @media ${ DEVICE_BREAKPOINT.minUltraDesktop } {
    max-width: 550px;
  }
`;

export const DocumentContainer = styled.div`
  padding: 40px 24px;
`;
